<template>
  <v-container grid-list-md class="pt-0 px-2 ma-0">
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-card flat v-if="lAction === 'view'">
          <v-card-title class="px-0 py-2">
            <v-layout class="pa-3">
              <v-flex xs6>
                <v-text-field
                class="pa-0"
                append-icon="mdi-account-search"
                :placeholder="$vuetify.breakpoint.smAndUp?'Search by Vendor Supplier Name, Phone, etc.':'Search'"
                hide-details
                v-model="search"
                outlined
                clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-download-as
                class="pt-1"
                :headers="vendorSm"
                :items="vendorList"
                title="Vendor Supplier List"
                ></v-download-as>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="py-3 px-0">
            <v-layout>
              <v-flex xs12>
                <v-data-table
                :headers="vendorSm"
                :items="vendorList"
                hide-default-footer
                disable-pagination
                :mobile-breakpoint="0"
                :search="search"
                sort-by="vendor_name"
                class="elevation-3 mt-3">
                <template slot="item" slot-scope="props">
                  <tr @click="prepareEditVendor(props.item)">
                    <td>{{ props.item.vendorsupplier_name ? props.item.vendorsupplier_name : '-' }}</td>
                    <td>{{ props.item.contact_name ? props.item.contact_name : '-' }}</td>
                    <td>{{ props.item.contact_phone ? props.item.contact_phone : '-' }}</td>
                    <td v-if="props.item.service_capability">
                      <span v-for="(service, i) in props.item.service_capability.split(', ')" :key="i">{{service}}<br/></span>
                    </td>
                    <td v-else>-</td>
                    <td>{{ props.item.vendor_status ? props.item.vendor_status : '-' }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-btn
      :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
      dark fab fixed color="accent" v-if="lAction === 'view'"
      @click.native="prepareCreate">
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <!-- create, update and delete of vendor supplier -->
    <v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0" fluid full-height>
      <v-layout row wrap>
        <v-flex xs12 md9 mx-auto class="ma-2">
          <v-form ref="vForm" @submit.prevent="saveVendorSupplierChanges(lAction)">
            <div class="title mb-2 pa-1">
              <v-btn small icon @click="Goback()"><v-icon>mdi-arrow-left</v-icon></v-btn>
              <span> {{lVendor.vendorsupplier_name ? lVendor.vendorsupplier_name : ''}}</span>
            </div>
            <v-expansion-panels :value="lAction === 'create' ? 0 : 1">
              <v-expansion-panel>
                <v-expansion-panel-header class="py-0">
                  <v-card-title class="pa-1">
                    {{ handy.startWithUpper(lAction) + ' Vendor Supplier' }}
                  </v-card-title>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card-text class="px-0 py-3">
                    <v-layout row wrap>
                      <v-flex xs12 sm6>
                        <v-text-field
                        v-model="lVendor.vendorsupplier_name"
                        label="Vendor-Supplier Name"
                        :rules="[rules.required]"
                        hide-details
                        maxlength="200"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                        v-model="lVendor.address"
                        label="Address"
                        hide-details
                        maxlength="250"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                        v-model="lVendor.contact_name"
                        label="Contact Person"
                        hide-details
                        maxlength="50"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                        v-model="lVendor.contact_phone"
                        label="Contact Number"
                        placeholder="Add Contact number with comma seperated"
                        hide-details
                        maxlength="200"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                        v-model="lVendor.contact_email"
                        label="Contact Email"
                        placeholder="Add Contact email with comma seperated"
                        hide-details
                        maxlength="200"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                        v-model="lVendor.contact_desig"
                        label="Contact Designation"
                        hide-details
                        maxlength="50"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                        v-model="lVendor.contact_landline"
                        label="Landline Number with STD code"
                        hide-details
                        type="Number"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                        v-model="lVendor.web_address"
                        label="Web Address"
                        hide-details
                        placeholder="Add Web Address with comma seperated"
                        maxlength="200"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                        v-model="lVendor.city"
                        label="City"
                        hide-details
                        maxlength="50"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                        v-model="lVendor.pin_code"
                        label="PIN Code"
                        hide-details
                        maxlength="10"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-select
                        v-model="lVendor.country_state_id"
                        :items="countryState"
                        label="State"
                        item-text="state_name"
                        item-value="country_state_id"
                        hide-details
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                        v-model="lVendor.gst_no"
                        label="GST Number"
                        hide-details
                        maxlength="25"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                        v-model="lVendor.pan_no"
                        label="PAN Number"
                        hide-details
                        maxlength="10"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-checkbox
                        v-model="lVendor.msme"
                        label="is_msme"
                        hide-details
                        class="shrink"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                        v-model="lVendor.bank_name"
                        label="Bank Name"
                        hide-details
                        maxlength="100"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                        v-model="lVendor.bank_address"
                        label="Bank Address"
                        hide-details
                        maxlength="100"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-select
                        v-model="lVendor.acount_type"
                        :items="['Saving', 'Current', 'CC', 'OD']"
                        label="Account Type"
                        hide-details
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                        v-model="lVendor.account_number"
                        label="Account Number"
                        hide-details
                        maxlength="50"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                        v-model="lVendor.ifsc_code"
                        label="IFSC Code"
                        hide-details
                        maxlength="15"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-select
                        v-model="lVendor.vendor_status"
                        :items="['Active', 'Inactive', 'Terminated']"
                        label="Status"
                        :rules="[rules.required]"
                        hide-details
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-checkbox label="Show To Smartility" hide-details
                        v-model="lVendor.show_to_smwebapp"></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn v-if="lAction === 'update' && serviceList.length < 1 && (docList && docList.length === 3 && docList[0].files.length === 0 && docList[1].files.length === 0 && docList[2].files.length === 0)" @click="deleteVendor(lVendor)">delete</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn type="submit" color="accent">Save</v-btn>
                  </v-card-actions>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- Add Vendor Supplier Services -->
              <v-expansion-panel v-if="lVendor.vendorsupplier_id">
                <v-expansion-panel-header>
                  <v-card-title class="pa-0">
                    Service Capability
                  </v-card-title>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card-text class="pa-0">
                    <div class="text-right">
                      <v-btn class="ml-2 mr-0 accent" small @click="prepareServiceCap(lVendor)">Add New</v-btn>
                    </div>
                    <v-data-table
                    class="elevation-1"
                    :headers="service"
                    :items="serviceList"
                    hide-default-footer
                    disable-pagination
                    :mobile-breakpoint="0">
                    <template slot="item" slot-scope="props">
                      <tr @click="prepareEditServices(props.item)">
                        <td>{{ props.item.service_type ? props.item.service_type : '-' }}</td>
                        <td>{{ props.item.vendorsupplier_cat ? props.item.vendorsupplier_cat : '-' }}</td>
                        <td>{{ props.item.vendorsupplier_sub_cat ? props.item.vendorsupplier_sub_cat : '-' }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Attach Vendor Supplier Attachments -->
            <v-expansion-panel v-if="lVendor.vendorsupplier_id">
              <v-expansion-panel-header>
                <v-card-title class="pa-0">
                  Supporting Documents
                </v-card-title>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card-text class="pa-0">
                  <v-flex xs12>
                    <v-data-table
                    :headers="fileHeaders"
                    :items="docList"
                    hide-default-footer
                    :mobile-breakpoint="0"
                    :sort-by="['vendor_supplier_attach_cat']"
                    class="elevation-1">
                    <template slot="item" slot-scope="props">
                      <tr>
                        <td style="width: 250px;">{{ props.item.vendor_supplier_attach_cat }}</td>
                        <td :class="props.item.files.length > 0 ? 'pt-2' : ''"><span v-for="(file, i) in props.item.files" :key="i">
                          <span v-if="file.is_selected">
                            <v-chip small close class="mb-2" @click:close="file.is_selected = false">
                              {{file.file_name}}
                              <a :href="handy.loadImg(file.file_url)" download style="text-decoration: none;">
                                <v-btn small icon class="mr-0 grey lighten-1 grey--text text--lighten-4 ml-2">
                                  <v-icon small>mdi-download</v-icon>
                                </v-btn>
                              </a>
                            </v-chip><br />
                          </span>
                        </span></td>
                        <td class="text-right pl-2 pr-0">
                          <input style="display:none" type="file" ref="fileInput"
                          accept=".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg"
                          multiple @change="loadFilesFromFileBrowser()"/>
                          <v-btn icon @click="pickFile(props.item.vendor_supplier_attach_cat)"><v-icon>mdi-upload</v-icon></v-btn>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-card-text>
              <v-card-actions class="pb-0">
                <v-spacer></v-spacer>
                <v-btn class="accent" @click="savedocuments()">save</v-btn>
              </v-card-actions>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-form>
    </v-flex>
  </v-layout>
</v-container>

<!-- Create/update/delete the services -->
<v-dialog v-model="showService" scrollable persistent max-width="500px">
  <v-flex xs12>
    <v-form ref="sForm" @submit.prevent="saveVendorSupplierServices(lService.action)">
      <v-card>
        <v-card-title class="py-2 px-3 title grey lighten-4">
          {{lService.action}} Services
        </v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-select
              v-model="lService.service_type"
              :items="['Vendor', 'Supplier']"
              label="Service Type"
              hide-details
              ></v-select>
            </v-flex>
            <v-flex xs10 class="pt-2">
              <v-select
              v-model="lService.vendorsupplier_cat_id"
              :items="vendorSupplierCategoryList"
              item-text="vendorsupplier_cat"
              item-value="vendorsupplier_cat_id"
              label="Vendor Supplier Category"
              @input="loadVendorSupplierSubCategory(lService)"
              hide-details
              ></v-select>
            </v-flex>
            <v-flex xs2 class="pt-3 text-right">
              <!-- <v-btn fab small class="accent" @click="prepareCreateCat(lService)"><v-icon>mdi-plus</v-icon></v-btn> -->
              <v-btn fab small class="accent" @click="ShowCatList = true"><v-icon>mdi-plus</v-icon></v-btn>
            </v-flex>
            <v-flex xs10 class="pt-2">
              <v-select
              v-model="lService.vendorsupplier_sub_cat_id"
              :items="vendorSupplierSubCategoryList"
              item-text="vendorsupplier_sub_cat"
              item-value="vendorsupplier_sub_cat_id"
              label="Vendor Supplier Sub-Category"
              hide-details
              ></v-select>
            </v-flex>
            <v-flex xs2 class="pt-3 text-right">
              <v-btn fab small class="accent" @click="loadAllSubCategory()"><v-icon>mdi-plus</v-icon></v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pb-3 pt-0">
          <v-spacer></v-spacer>
          <v-btn @click="showService = false">close</v-btn>
          <v-btn v-if="lService.action === 'Update'" @click="deleteVendorSupplierServices(lService)">delete</v-btn>
          <v-btn type="submit" class="accent">save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-flex>
</v-dialog>

<!-- showing list of vendor supllier category -->
<v-dialog v-model="ShowCatList" max-width="500px">
  <v-card>
    <v-card-title class="py-2 px-3 title grey lighten-4">
      Vendor Supplier Category
      <v-spacer></v-spacer>
      <v-btn icon @click="ShowCatList = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <div class="py-2 text-right">
        <v-btn class="ml-2 mr-0 accent" small @click="prepareCreateCat(lVendor)">Add New</v-btn>
      </div>
      <v-data-table
      class="elevation-1"
      :headers="vendorCategoryHead"
      :items="vendorSupplierCategoryList"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0">
      <template slot="item" slot-scope="props">
        <tr @click="prepareUpdateCat(props.item)">
          <td>{{ props.item.vendorsupplier_cat ? props.item.vendorsupplier_cat : '-' }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-dialog>

<!-- Create/update/delete the category -->
<v-dialog v-model="showCat" scrollable max-width="500px">
  <v-flex xs12>
    <v-form ref="cForm" @submit.prevent="saveVendorSupplierCat(lCat.action)">
      <v-card>
        <v-card-title class="py-2 px-3 title grey lighten-4">
          {{lCat.action}} Vendor Supplier Category
        </v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
              v-model="lCat.vendorsupplier_cat"
              label="Vendor Supplier Category"
              :rules="[rules.required]"
              hide-details
              maxlength="100">
            </v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions class="pb-3 pt-0">
        <v-spacer></v-spacer>
        <v-btn @click="showCat = false">close</v-btn>
        <v-btn v-if="lCat.action === 'Update'" @click="deleteVendorSupplierCat(lCat)">delete</v-btn>
        <v-btn type="submit" class="accent">save</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</v-flex>
</v-dialog>

<!-- showing list of vendor supllier category -->
<v-dialog v-model="ShowSubCatList" max-width="500px">
  <v-card>
    <v-card-title class="py-2 px-3 title grey lighten-4">
      Vendor Supplier Sub-Category
      <v-spacer></v-spacer>
      <v-btn icon @click="ShowSubCatList = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <div class="py-2 text-right">
        <v-btn class="ml-2 mr-0 accent" small @click="prepareCreateSubCat(lVendor)">Add New</v-btn>
      </div>
      <v-data-table
      class="elevation-1"
      :headers="vendorSubCategoryHead"
      :items="allVendorSupplierSubCategoryList"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0">
      <template slot="item" slot-scope="props">
        <tr @click="prepareUpdateSubCat(props.item)">
          <td>{{ props.item.vendorsupplier_sub_cat ? props.item.vendorsupplier_sub_cat : '-' }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-dialog>

<!-- Create/update/delete the Subcategory -->
<v-dialog v-model="showSubCat" scrollable max-width="500px">
  <v-flex xs12>
    <v-form ref="cForm" @submit.prevent="saveVendorSupplierSubCat(lSubCat.action)">
      <v-card>
        <v-card-title class="py-2 px-3 title grey lighten-4">
          {{lSubCat.action}} Vendor Supplier Sub-Category
        </v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-select
              v-model="lSubCat.vendorsupplier_cat_id"
              :items="vendorSupplierCategoryList"
              item-text="vendorsupplier_cat"
              item-value="vendorsupplier_cat_id"
              label="Vendor Supplier Category"
              hide-details
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <v-text-field
              v-model="lSubCat.vendorsupplier_sub_cat"
              label="Vendor Supplier Sub-Category"
              :rules="[rules.required]"
              hide-details
              maxlength="100">
            </v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions class="pb-3 pt-0">
        <v-spacer></v-spacer>
        <v-btn @click="showSubCat = false">close</v-btn>
        <v-btn v-if="lSubCat.action === 'Update'" @click="deleteVendorSupplierSubCat(lSubCat)">delete</v-btn>
        <v-btn type="submit" class="accent">save</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</v-flex>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="4000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-col>
</v-row>
</v-container>
</template>

<script>
import handy from '@/utils/handy'
import config from '@/config/app-cfg'
import VDownloadAs from './VDownloadAs.vue'

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      // common
      lAction: '',
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      handy: handy,
      rules: handy.rules,
      // vendor supplier
      search: '',
      beingSaved: false,
      lVendor: [],
      countryState: [],
      service: [
        { text: 'Service Type', value: 'service_type', width: '220px' },
        { text: 'Vendorsupplier Category', value: 'vendorsupplier_cat', width: '240px' },
        { text: 'Vendorsupplier Sub-category', value: 'vendorsupplier_sub_cat' }
      ],
      serviceList: [],
      lService: [],
      showService: false,
      vendorSm: [
        { text: 'Vendor Supplier Name', value: 'vendorsupplier_name' },
        { text: 'Contact Person', value: 'contact_name' },
        { text: 'Contact Phone', value: 'contact_phone' },
        { text: 'Service Capablity', value: 'service_capability' },
        { text: 'Vendor Supplier Status', value: 'vendor_status' }
      ],
      vendorList: [],
      vendorSupplierCategoryList: [],
      vendorSupplierSubCategoryList: [],
      vendorCategoryHead: [
        { text: 'Vendor Supplier Category', value: 'vendorsupplier_cat' }
      ],
      ShowCatList: false,
      showCat: false,
      lCat: [],
      showSubCat: false,
      lSubCat: [],
      vendorSubCategoryHead: [
        { text: 'Vendor Supplier Sub-Category', value: 'vendorsupplier_sub_cat' }
      ],
      ShowSubCatList: false,
      allVendorSupplierSubCategoryList: [],
      fileHeaders: [
        { text: 'Documents', value: 'vendor_supplier_attach_cat' },
        { text: 'file', value: 'files' },
        { text: '', value: '' }
      ],
      docList: [],
      curDocType: '',
      docType: ['Cancelled Cheque', 'Master Agreements with T&C', 'Work Orders']
    }
  },
  mounted () {
    this.lAction = 'view'
    this.loadVendorSupplier()
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    prepareCreate () {
      this.lVendor = {
        vendor_id: config.VENDOR_ID,
        vendorsupplier_name: '',
        contact_phone: null,
        contact_email: '',
        contact_name: '',
        contact_desig: '',
        contact_landline: null,
        web_address: '',
        address: '',
        city: '',
        pin_code: '',
        country_state_id: null,
        gst_no: '',
        pan_no: '',
        msme: false,
        bank_name: '',
        bank_address: '',
        acount_type: '',
        account_number: null,
        ifsc_code: '',
        vendor_status: ''
      }
      this.serviceList = []
      this.loadCountryState()
      this.loadDocType()
      this.lAction = 'create'
    },
    loadCountryState () {
      this.axios.get(config.API_URL + '/getCountryStateList/')
      .then(response => {
        this.countryState = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    saveVendorSupplierChanges (action) {
      // validate and save Changes
      if (this.$refs.vForm.validate()) {
        this.beingSaved = true
        // pre-requsite
        this.lVendor.vendor_id = config.VENDOR_ID
        this.axios.post(config.API_URL + '/vendorSupplier/' + action, this.lVendor)
        .then(response => {
          this.lVendor.vendorsupplier_id = response.data
          this.loadVendorSupplier()
          this.beingSaved = false
          this.msg('Saved Successfully', 1)
          this.lAction = 'update'
        })
        .catch(err => {
          this.msg(err, 0)
          this.beingSaved = false
        })
      }
    },
    loadVendorSupplier () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getVendorSupplierList/', qry)
      .then(response => {
        this.vendorList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareEditVendor (curRec) {
      this.lVendor = Object.assign({}, curRec) // keep the original object safely before changes
      this.loadServiceCapability (this.lVendor)
      this.loadCountryState()
      this.loadDocType(curRec.vendorsupplier_id)
      this.lAction = 'update'
    },
    loadServiceCapability (curVendorSupplier) {
      var qry = {
        params: {
          vendorsupplier_id: curVendorSupplier.vendorsupplier_id
        }
      }
      this.serviceList = []
      this.axios.get(config.API_URL + '/getServiceCapablityBasedOnVendorSupplierId/', qry)
      .then(response => {
        this.serviceList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareServiceCap (curVendorSupplier) {
      this.lService = {
        service_type: '',
        vendorsupplier_cat_id: null,
        vendorsupplier_sub_cat_id: null,
        vendorsupplier_id: curVendorSupplier.vendorsupplier_id,
        action: 'Create'
      }
      this.vendorSupplierCategoryList = []
      this.vendorSupplierSubCategoryList = []
      this.loadVendorSupplierCategory(curVendorSupplier)
      this.showService = true
    },
    loadVendorSupplierCategory (curVendorSupplier) {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getVendorSupplierCategoryBasedOnVendorId/', qry)
      .then(response => {
        this.vendorSupplierCategoryList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadVendorSupplierSubCategory (curService) {
      var qry = {
        params: {
          vendorsupplier_cat_id: curService.vendorsupplier_cat_id
        }
      }
      this.axios.get(config.API_URL + '/getVendorSupplierSubCategoryBasedOnVendorSupplierId/', qry)
      .then(response => {
        this.vendorSupplierSubCategoryList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    saveVendorSupplierServices (action) {
      // validate and save Changes
      if (this.lService.vendorsupplier_cat_id && this.lService.service_type && this.lService.vendorsupplier_sub_cat_id) {
        if (this.$refs.sForm.validate()) {
          this.axios.post(config.API_URL + '/vendorSupplierService/' + action, this.lService)
          .then(response => {
            this.showService = false
            this.lService.action = 'view'
            this.loadServiceCapability(this.lService)
          })
          .catch(err => {
            this.msg(err.response.data, 0)
          })
        }
      } else {
        this.msg('Please fill all field', 0)
      }
    },
    prepareEditServices (curVendorSupplier) {
      this.lService = Object.assign({}, curVendorSupplier)
      this.lService.old_vendorsupplier_cat_id = curVendorSupplier.vendorsupplier_cat_id
      this.lService.old_vendorsupplier_sub_cat_id = curVendorSupplier.vendorsupplier_sub_cat_id
      this.lService.old_service_type = curVendorSupplier.service_type
      this.lService.action = 'Update'
      this.loadVendorSupplierCategory(curVendorSupplier)
      this.loadVendorSupplierSubCategory(curVendorSupplier)
      this.showService = true
    },
    deleteVendorSupplierServices (curVendorSupplier) {
      if (!confirm('Sure, you want to delete the Services with "' + curVendorSupplier.vendorsupplier_cat + ' - ' + curVendorSupplier.vendorsupplier_sub_cat + '"?')) {
        return
      }
      this.axios.post(config.API_URL + '/vendorSupplierService/Delete', curVendorSupplier)
      .then(response => {
        this.showService = false
        this.lService.action = 'view'
        this.loadServiceCapability(this.lService)
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareCreateCat (curCategory) {
      this.lCat = {
        vendorsupplier_cat: '',
        vendor_id: config.VENDOR_ID,
        action: 'Create'
      }
      this.showCat = true
    },
    saveVendorSupplierCat (action) {
      // validate and save Changes
      if (this.$refs.cForm.validate()) {
        this.lCat.vendor_id = config.VENDOR_ID
        this.axios.post(config.API_URL + '/vendorSupplierServiceCat/' + action, this.lCat)
        .then(response => {
          this.lCat.vendorsupplier_cat_id = response.data
          this.showCat = false
          this.lCat.action = 'view'
          this.loadVendorSupplierCategory(this.lCat)
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    prepareUpdateCat (curCategory) {
      this.lCat = Object.assign({}, curCategory)
      this.lCat.action = 'Update'
      this.showCat = true
    },
    deleteVendorSupplierCat (curCategory) {
      if (!confirm('Sure, you want to delete the Category with "' + curCategory.vendorsupplier_cat + '"?')) {
        return
      }
      this.axios.post(config.API_URL + '/vendorSupplierServiceCat/Delete', curCategory)
      .then(response => {
        this.showCat = false
        this.lCat.action = 'view'
        this.loadVendorSupplierCategory(this.lCat)
      })
      .catch(err => {
        this.msg('Having reference in sub category', 0)
      })
    },
    prepareCreateSubCat (curService) {
      this.lSubCat = {
        vendorsupplier_cat_id: null,
        vendorsupplier_sub_cat: '',
        action: 'Create'
      }
      this.loadVendorSupplierSubCategory(curService)
      this.showSubCat = true
    },
    saveVendorSupplierSubCat (action) {
      // validate and save Changes
      if (this.$refs.cForm.validate()) {
        this.axios.post(config.API_URL + '/vendorSupplierServiceSubCat/' + action, this.lSubCat)
        .then(response => {
          this.lSubCat.vendorsupplier_sub_cat_id = response.data
          this.showSubCat = false
          this.lSubCat.action = 'view'
          this.loadVendorSupplierSubCategory(this.lService)
          this.loadAllSubCategory()
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    loadAllSubCategory () {
      this.axios.get(config.API_URL + '/getAllVendorSupplierSubCategory/')
      .then(response => {
        this.allVendorSupplierSubCategoryList = response.data
        this.ShowSubCatList = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareUpdateSubCat (curSubCategory) {
      this.lSubCat = Object.assign({}, curSubCategory)
      this.lSubCat.action = 'Update'
      this.showSubCat = true
    },
    deleteVendorSupplierSubCat (curSubCategory) {
      if (!confirm('Sure, you want to delete the Category with "' + curSubCategory.vendorsupplier_sub_cat + '"?')) {
        return
      }
      this.axios.post(config.API_URL + '/vendorSupplierServiceSubCat/Delete', curSubCategory)
      .then(response => {
        this.showSubCat = false
        this.lSubCat.action = 'view'
        this.loadAllSubCategory()
      })
      .catch(err => {
        this.msg('Having reference in service capability', 0)
      })
    },
    deleteVendor (curVendor) {
      if (!confirm('Sure, you want to delete the Vendor with "' + curVendor.vendorsupplier_name + '"?')) {
        return
      }
      this.beingSaved = true
      this.axios.post(config.API_URL + '/vendorSupplier/delete', curVendor)
      .then(response => {
        this.beingSaved = false
        this.loadVendorSupplier()
        this.msg('Deleted Successfully', 1)
        this.lAction = 'view'
      })
      .catch(err => {
        this.msg(err, 0)
        this.beingSaved = false
      })
    },
    Goback () {
      this.lAction = 'view'
      this.loadVendorSupplier()
    },
    pickFile (curDoc) {
      this.curDocType = curDoc
      this.$refs.fileInput.click()
    },
    loadFilesFromFileBrowser (curDoc) {
      var idx = this.docList.findIndex(rec => rec.vendor_supplier_attach_cat === this.curDocType)
      const files = event.target.files
      Array.from(files).forEach((file) => {
        const fileReader = new FileReader()
        const getResult = new Promise(resolve => {
          fileReader.onload = e => {
            var fIdx = this.docList[idx].files.findIndex(rec => rec.file_name === file.name)
            if (fIdx < 0) {
              this.docList[idx].files.push({
                file_url: e.target.result.split(',')[1],
                file_name: file.name,
                is_selected: true,
                is_changed: true
              })
            } else {
              this.msg('File with the same name is already exists: "' + file.name + '" in "' + this.curDocType + '"')
            }
            this.$forceUpdate()
          }
        })
        fileReader.readAsDataURL(file)
        return getResult.then(file => {
          return file
        })
      })
    },
    savedocuments () {
      this.docList[0].vendor_id = config.VENDOR_ID
      this.docList[0].vendorsupplier_id = this.lVendor.vendorsupplier_id
      this.axios.post(config.API_URL + '/VendorDocuments/', this.docList)
      .then(response => {
        // commit the changes in front end as well
        this.loadDocType(this.docList[0].vendorsupplier_id)
        this.msg('Saved Successfully', 1)
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadDocType (curVendorsupplierId = null) {
      var qry = {
        params: {
          vendorsupplier_id: curVendorsupplierId
        }
      }
      this.docList = []
      this.axios.get(config.API_URL + '/getDocumentsBasedOnVendorSupplierId/', qry)
      .then(response => {
        var docTypeList = response.data.map(rec => rec.vendor_supplier_attach_cat)
        for (var i = 0; i < response.data.length; i++) {
          this.docList.push({
            vendorsupplier_id: response.data[i].vendorsupplier_id,
            vendor_supplier_attach_cat: response.data[i].vendor_supplier_attach_cat,
            file_url: response.data[i].file_url,
            files: []
          })
        }
        // fill-in gaps
        this.docType.forEach(type => {
          var cIdx = docTypeList.indexOf(type)
          if (cIdx < 0) {
            this.docList.push({
              vendorsupplier_id: curVendorsupplierId,
              vendor_supplier_attach_cat: type,
              file_url: '',
              files: []
            })
          }
        })

        var path = require('path')
        var files = ''
        this.docList.forEach(rec => {
          files = ''
          if (rec.file_url) {
            files = rec.file_url.split(',')
            if (files.length > 0) {
              files.forEach(file => {
                rec.files.push({
                  file_url: file,
                  file_name: file ? path.basename(file) : '',
                  is_selected: true,
                  is_changes: false
                })
              })
            }
          }
        })
      })
      .catch(err => {
        this.msg(err)
      })
    }
  }
}
</script>
